/* eslint-disable @typescript-eslint/no-explicit-any */

import {ProductEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks/useHostName';

declare global {
	interface Window {
		ht: {
			removeListenersFromIframe: (props: any) => void;
			removeListenersFromIframes: () => void;
			addListenersToIframe: (props: any) => void;
			addListenersToIframes: () => void;
			destroy: () => void;
		};
		HT: any;
	}
}

export const useHandTalk = () => {
	const {dataHostNameState} = useHostName();

	const handTalkToken = {
		[ProductEnum.GNDI_MINAS]: '8538b6021707ae7ebf52875aae94ffe8',
		[ProductEnum.CLINIPAM]: '3ce69314fc6f08dfa54c3f0826773087',
		[ProductEnum.CCG]: '5e5b1a0b1d7be497fb1c40b58ab7cf74',
		[ProductEnum.HAP]: '2789c9b1464fb8affde65b6ce86e663e',
		[ProductEnum.GNDI]: '47c357dd3ba414af88c358107493bb35',
		[ProductEnum.NOTREDAME_SAUDE]: '47c357dd3ba414af88c358107493bb35',
	};

	const handleOnHandTalkLoad = () => {
		window.ht = new window.HT({
			token: handTalkToken[dataHostNameState.product],
			align: 'center',
		});
	};

	const handTalkScript = {src: 'https://plugin.handtalk.me/web/latest/handtalk.min.js'};

	return {handTalkScript, handleOnHandTalkLoad};
};
